<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M16.6663 17.7083L15.182 16.25L19.9736 11.4583L15.182 6.66667L16.6663 5.20833L22.9163 11.4583L16.6663 17.7083ZM2.08301 19.7917V15.625C2.08301 14.184 2.59082 12.9557 3.60645 11.9401C4.62207 10.9245 5.85037 10.4167 7.29134 10.4167H13.7236L9.97363 6.66667L11.458 5.20833L17.708 11.4583L11.458 17.7083L9.97363 16.25L13.7236 12.5H7.29134C6.42329 12.5 5.68544 12.8038 5.0778 13.4115C4.47016 14.0191 4.16634 14.7569 4.16634 15.625V19.7917H2.08301Z"
      fill="currentColor"
    />
  </svg>
</template>
